import { render, staticRenderFns } from "./ZipAssets.vue?vue&type=template&id=5d10faa7&scoped=true&"
import script from "./ZipAssets.vue?vue&type=script&lang=js&"
export * from "./ZipAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10faa7",
  null
  
)

export default component.exports